import React from 'react'
import { l } from '@manychat/manyui'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { EmptyState } from 'apps/aiAutomation/pages/Skills/components/EmptyState'

import cm from './styles.module.css'

export const GoalTypePicker = () => {
  return (
    <div className={cm.wrapper}>
      <SidebarHeader title={l.translate('New goal')} />

      <div className="p-a-md o-auto">
        <p className="m-b text-subheading">
          {l.translate('What goal do you want AI to help you achieve?')}
        </p>

        <EmptyState />
      </div>
    </div>
  )
}
